import React, { useState, useEffect } from "react";
import axios from "axios";
import AddressLogs from "./AddressLogs";

function DashboardHome() {
  const [stats, setStats] = useState({
    totalAddresses: 0,
    totalSavings: 0,
    poBoxBlocked: 0,
    ruralFlagged: 0,
    usageCount: 0,
    usageLimit: 100,
  });
  const shop =
    new URLSearchParams(window.location.search).get("shop") ||
    "victorgroups.myshopify.com";

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await axios.get(
          `http://localhost:3000/validations?shop=${shop}`,
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        const {
          totalAddresses,
          totalSavings,
          byStatus,
          usageCount,
          usageLimit,
        } = response.data.data || {};
        setStats({
          totalAddresses: totalAddresses || 0,
          totalSavings: totalSavings || 0,
          poBoxBlocked: byStatus?.pobox || 0,
          ruralFlagged: byStatus?.rural || 0,
          usageCount: usageCount || stats.usageCount,
          usageLimit: usageLimit || stats.usageLimit,
        });
      } catch (error) {
        console.error("❌ Analytics fetch error:", error.message);
      }
    };
    fetchStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shop]);

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          Merchant Dashboard
        </h1>

        {/* ROI Stats */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h2 className="text-xl font-semibold text-gray-700">
              Failed Deliveries Prevented
            </h2>
            <p className="text-4xl font-bold text-blue-600">
              {stats.totalAddresses}
            </p>
            <p className="text-gray-500 mt-2">This month</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h2 className="text-xl font-semibold text-gray-700">
              $ Saved This Month
            </h2>
            <p className="text-4xl font-bold text-green-600">
              ${stats.totalSavings.toLocaleString()}
            </p>
            <p className="text-gray-500 mt-2">Estimated savings</p>
          </div>
        </div>

        {/* Risk Report */}
        <div className="bg-white p-6 rounded-lg shadow-md mb-8">
          <h2 className="text-xl font-semibold text-gray-700 mb-4">
            Risk Report
          </h2>
          <div className="flex justify-between">
            <p className="text-gray-600">
              🚫 {stats.poBoxBlocked} PO Boxes blocked
            </p>
            <p className="text-gray-600">⚠️ {stats.ruralFlagged} rural flags</p>
          </div>
        </div>

        {/* Usage Meter */}
        <div className="bg-white p-6 rounded-lg shadow-md mb-8">
          <h2 className="text-xl font-semibold text-gray-700 mb-4">
            Usage & Billing
          </h2>
          <div className="w-full bg-gray-200 rounded-full h-4">
            <div
              className="bg-green-600 h-4 rounded-full"
              style={{
                width: `${(stats.usageCount / stats.usageLimit) * 100}%`,
              }}
            ></div>
          </div>
          <p className="text-gray-600 mt-2">
            {stats.usageCount} / {stats.usageLimit} free validations used
          </p>
          <a
            href="/subscription"
            className="mt-4 inline-block bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
          >
            Upgrade Plan
          </a>
        </div>

        {/* Logs Section */}
        <AddressLogs />
      </div>
    </div>
  );
}

export default DashboardHome;
